import { FUND_INFO, KUSPIT_LEGAL_NOTICE } from "@aventuria/client-core/disclosures";
import { ExternalLink, ShieldCheck } from "lucide-react";
import { DisclosureParagraphText } from "../../components/Disclosures";

/**
 * "Conoce cómo se invierte tu dinero" (C6.5 / "Más info"): the fund, Kuspit's role and the risk notice.
 * The fund description and the notice are Legal's text (client review 2026-10-13), shared with the app.
 * `fundLabel`/`infoText` from the settings are no longer shown; the documents link lives in the text.
 */
export function InvestmentInfo({ prospectusUrl, fundInfoUrl }: { fundLabel?: string; infoText?: string; prospectusUrl: string; fundInfoUrl: string }) {
  return (
    <section className="card investment-info" translate="no">
      <span className="page-eyebrow">Tu inversión</span>
      <h2>Conoce cómo se invierte tu dinero</h2>
      {[...FUND_INFO.summary, ...FUND_INFO.more].map((paragraph, index) => <DisclosureParagraphText key={index} paragraph={paragraph} />)}
      <p>Al crear o abonar un Apartado no se compra otro fondo: tu dinero permanece invertido en el mismo fondo y Aventuria registra qué parte de tu saldo queda destinada a cada viaje. Al retirar de Wallet Libre, primero se venden los títulos necesarios y, una vez liquidados, se envía tu transferencia SPEI.</p>
      <div className="investment-block">
        <span className="benefit-icon"><ShieldCheck size={17} aria-hidden="true" /></span>
        <div>
          <strong>Información importante</strong>
          {KUSPIT_LEGAL_NOTICE.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </div>
      </div>
      {(prospectusUrl || fundInfoUrl) && (
        <div className="inline-actions">
          {prospectusUrl && <a className="secondary-button small" href={prospectusUrl} target="_blank" rel="noreferrer">Consultar prospecto del fondo <ExternalLink size={13} aria-hidden="true" /></a>}
          {fundInfoUrl && <a className="secondary-button small" href={fundInfoUrl} target="_blank" rel="noreferrer">Ver ficha informativa del fondo <ExternalLink size={13} aria-hidden="true" /></a>}
        </div>
      )}
    </section>
  );
}
